import * as React from 'react';
import {Field, FieldArray, formValueSelector, reduxForm, InjectedFormProps, submit} from 'redux-form';
import {flow, map, forEach, size, difference, isEmpty, find, get} from 'lodash';
import {II18nMessages} from '../../../../services/branding/models';
import {Button, Col, ControlLabel, Form, FormGroup, Row, Modal, Popover, OverlayTrigger} from 'react-bootstrap';
import FieldFormControl from '../../../../components/FieldFormControl';
import {connect} from 'react-redux';
import AlternativeDatePicker from '../../../../components/AlternativeDatePicker/index';
import {
  IChannel, IDestination, IProduct, IOccupation, IIndustry,
  IPolicyApplication, ITraveller,
} from '../../../../data/api/models';
import {
  isFutureDate, isRequired, isValidDate, annualLimit, singleLimitMonths, singleMaxTripDuration, isNotGreaterThan,
  isNotLessThan,
} from '../../../../util/validators';
import * as moment from 'moment';
import {showRegions} from '../../../../data/api/api';
import {actions as quoteActions, getInitValues} from '../../../../services/quote/reducer';
import {IAuthState} from '../../../../services/auth/models';
import {bindActionCreators} from 'redux';
import {IQuoteActions} from '../../../../services/quote/models';
import Travellers from './components/Travellers';
import FaCheck from 'react-icons/fa/check';
import FaChevronRight from 'react-icons/fa/chevron-right';
import VoucherCode from '../../components/VoucherCode';
import MarketingOptions from '../../components/MarketingOptions';
import {IStore} from '../../../../redux/IStore';
import * as Commonmark from 'react-commonmark';
import FaInfoCircle from 'react-icons/fa/info-circle';
import RegionSelected from './components/RegionSelect/RegionSelected';
import CovidStatement from '../TripDetails/components/CovidStatement';

interface ITripDetailsFormProps extends InjectedFormProps {
  destinations: IDestination[];
  occupations: IOccupation[];
  industries: IIndustry[];
  auth: IAuthState;
  i18n: II18nMessages;
  travellers: ITraveller[];
  groupType: string;
  cruiseCover: boolean;
  tripType: string;
  startDate: string;
  region: string;
  maxTripDuration: string;
  schemeId: string;
  endDate: string;
  dispatch: any;
  product: IProduct;
  destinationsValue: string[];
  occupationValue: string[];
  industryValue: string[];
  channel: IChannel;
  quote: IPolicyApplication;
  topUpCover: number;
  totalTopUpCover: number;
  existingProvider: string;
  underlyingCover: string;
  holidayValue: string;

  renderDefinition(name: string): any;

  actions: {
    quote: IQuoteActions;
    submit(name: string);
  };
}

interface ITripDetailsStates {
  showBlockerModal: boolean;
  modalMessage: string;
  input: string;
  additionalCover: boolean;
  showSmallDesc: boolean;
}

class TripDetailsForm extends React.Component<ITripDetailsFormProps, ITripDetailsStates> {
  public state = {
    showBlockerModal: false,
    modalMessage: '',
    input: '',
    additionalCover: false,
    showSmallDesc: false,
  };

  public componentWillMount() {
    const {product, change, initialValues, dispatch, channel, auth} = this.props;

    const data = getInitValues(product, null, null);

    forEach(data, (value, key) => {
      if (initialValues[key] === null) {
        change(key, value);
      }
    });

    const dateFromApi = (date) => {
      if (!date) {
        return '';
      }

      const parsedDate = moment(date).format('DD/MM/YYYY');

      return parsedDate !== 'Invalid Date' ? parsedDate : '';
    };

    dispatch(change('salesChannel', channel.key));
    dispatch(change('quotationTypes', 'Direct'));
    // dispatch(change('emailSend', false));

    if (auth.isAuthenticated) {
      dispatch(change('travellers[0].title', auth.customer.title));
      dispatch(change('travellers[0].dob', dateFromApi(auth.customer.dob)));
      dispatch(change('travellers[0].firstName', auth.customer.firstName));
      dispatch(change('travellers[0].lastName', auth.customer.lastName));
      dispatch(change('travellers[0].email', auth.customer.email));
      dispatch(change('travellers[0].phone', auth.customer.phone1));
      dispatch(change('travellers[0].address.postcode', auth.customer.address.postcode));
      dispatch(change('travellers[0].address.line1', auth.customer.address.line1));
      dispatch(change('travellers[0].address.line2', auth.customer.address.line2));
      dispatch(change('travellers[0].address.town', auth.customer.address.town));
      dispatch(change('travellers[0].address.country', auth.customer.address.country));
    }
  }

  public componentDidUpdate() {
    const {tripType, dispatch, change, channel } = this.props;
    const regionTripType = tripType;

    if (regionTripType === 'single' && channel.key === 'tumc-b2c') {
      dispatch(change('region', 'worldwide'));
      dispatch(change('maxTripDuration', ''));
    } else if (regionTripType === 'single' && channel.key === 'cpi-b2c') {
      dispatch(change('region', 'uk'));
      dispatch(change('maxTripDuration', ''));
    }
  }

  private getAge = (dob) => {

    if (isEmpty(dob)) {
      return null;
    }

    const convertedDate = dob.split(/\//).reverse().join('/');
    return moment().diff(convertedDate, 'years');
  }

  public handleChange(e) {
    this.setState({ input: e.target.value });
  }

  public componentWillReceiveProps(nextProps) {
    const {tripType, dispatch, change, actions, schemeId} = this.props;

    if (schemeId && tripType !== nextProps.tripType) {
      dispatch(change('schemeId', ''));
      actions.quote.calculate(null, true);
    }
  }

  public renderAboutUs = () => {
    const {channel} = this.props;
    const TERMS_OF_BUSINESS = 'Terms of Business';
    const aiosDocument = find(channel.productDocuments, (document) => {
      return document.shortName === TERMS_OF_BUSINESS;
    });
    const aboutUsUrl = aiosDocument ? aiosDocument.filePath : '';

    let privacyUrl =  '/privacy';

    if (['tumc-b2c'].includes(channel.key)) {
      privacyUrl = 'https://www.topupmycancellationcover.com/documents/Socprivacypolicy.pdf';
    }

    return (
      <div className="margin-top margin-bottom">
        For more information about our service to you and how we will use your information,
        please read our <a href={aboutUsUrl} target="_blank" className="link-secondary-color">Terms of Business </a>
        and our <a href={privacyUrl} target="_blank" className="link-secondary-color">Privacy Policy</a>.
      </div>
    );
  }

  private checkForErrorBeforeSubmit = () => {
    const { actions } = this.props;
    actions.submit('quote');
  }

  private closeBlockerModal = () => {
    this.setState({
      showBlockerModal: false,
    });
  }

  private renderBlockerModal = () => {
    const {channel} = this.props;
    const {modalMessage, additionalCover} = this.state;

    const messages = modalMessage.split('<br />');

    return (
      <Modal show={this.state.showBlockerModal} onHide={this.closeBlockerModal}>
        <Modal.Header closeButton={true}>
          <Modal.Title>Attention required</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            <ul>
              {additionalCover ? (
                <li>
                  <>
                    Sorry, we are unable to provide a quote due to the “top up” amount you have selected, which
                    exceeds the limit of this policy. <br /><br /> We do, however, have an alternative policy -
                    ‘High Value Travel Cancellation
                    insurance’.{' '}
                    <a href="https://www.pjhayman.com/travel-insurance/high-value-travel-cancellation-insurance/"
                    target="_blank">
                    Click here</a>{' '}
                    for details and to apply for a quote. <br /><br /> Alternatively, please call our specialist
                    UK-based customer services team on
                  </>
                </li>
              ) : (
                <>
                  {map(messages, (message) => {
                    return <div><br />{message}</div>;
                  })}
                </>
              )}
              <strong>{channel.phone}</strong> ({channel.openingHours}, closed Bank Holidays).
            </ul>
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            bsStyle="primary"
            onClick={this.closeBlockerModal}
          >
            CLOSE
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }

  public render() {
    const {
      i18n,
      submitting,
      tripType,
      handleSubmit,
      valid,
      startDate,
      product,
      renderDefinition,
      submitFailed,
      groupType,
      change,
      channel,
    } = this.props;

    const renderTitle = 'Trip details';

    const maxDateSingle = () => {
      return moment(startDate, 'DD/MM/YYYY').add('18', 'months').format().toString();
    };

    const tripDurations = {
      TUMC: 547,
      CPI: 45,
    };
    const deferredDays = {
      TUMC: 548,
      CPI: 548,
    };

    const infoIconExistingProvider = (
      <Popover id="popover-trigger-click-root-close" title="Existing Provider ">
        <Commonmark source={'Who is your current travel insurance provider?'} />
      </Popover>
    );

    const infoIconExistingCover = (
      <Popover id="popover-trigger-click-root-close" title="Existing Cover">
        <Commonmark source={'Your existing cover must provide a minimum of £1000 per person.\n' +
        'Please do not use £ signs or commas when entering the amount – e.g 1000'} />
      </Popover>
    );

    const infoIconHolidayValue = (
      <Popover id="popover-trigger-click-root-close" title="Holiday Value">
        <Commonmark source={'Enter the value of your holiday.'} />
      </Popover>
    );

    const infoIconAdditionalCover = (
      <Popover id="popover-trigger-click-root-close" title="Additional Cover">
        <Commonmark source={'Enter the additional top up amount required per person. Please do not use £ signs ' +
        'or commas when entering the amount e.g. 5000.  Maximum additional cover available £20000 per person ' +
        '(reduced to £15000 per person if aged 75 and over).'} />
      </Popover>
    );

    const infoIconPolicyType = (
      <Popover id="popover-trigger-click-root-close" title="Policy Type">
        <Commonmark
          source={'Cover for a specified single trip not exceeding the maximum trip duration as shown in your main ' +
          'travel insurance policy. Maximum age 79.'}
        />
      </Popover>
    );

    const infoIconStartDate = (
      channel.key === 'tumc-b2c' ? (
        <Popover id="popover-trigger-click-root-close" title="Start Date">
          <Commonmark
            source={
              'Please select the Start Date of your Trip.\n\n' +
              'Please Note: there is a waiting period of 7 days from the time that you take out your policy. If\n' +
              'anything occurs in this period, or you are aware of anything that could give rise to a claim prior\n' +
              'to taking out your Top Up Cancellation policy, you will not be covered.'
            }
          />
        </Popover>
      ) : (
        <Popover id="popover-trigger-click-root-close" title="Start Date">
          <Commonmark
            source={'Please select the Start Date of your Trip.'}
          />
        </Popover>
      )
    );

    const infoIconEndDate = (
      <Popover id="popover-trigger-click-root-close" title="End Date">
        <Commonmark
          source={'Please select the End Date of your Trip.'}
        />
      </Popover>
    );

    const minAdditionalCover = 1000;

    const returnStartDate = moment(startDate, 'DD/MM/YYYY');

    // if (returnStartDate && channel.key === 'cpi-b2c') {
    //   returnStartDate = returnStartDate.add('45', 'days').format('DD/MM/YYYY').toString();
    // }

    const advancedDays = 547;
    const covidMessage = get(product.metadata, 'covid_message.travel_detail_b2c', '');

    return (
      <Form horizontal={true} onSubmit={handleSubmit} autoComplete="off">
        <div className="steps-container">
          <div className="section-title">
            <h3>{renderTitle}</h3>
          </div>
          <CovidStatement covidMessage={covidMessage}/>
          {channel.key === 'cpi-b2c' && (
            <FormGroup controlId="trip-type" style={{ paddingLeft: '12px' }}>
              <Row>
                <Col sm={12} className="summary-info cpi-destination">
                  <Row>
                    <Col xs={3}>
                      Destination(s)
                    </Col>
                    <Col xs={9}>
                      <Row className="destination-radio">
                        {map(product.metadata.regions, (name, key) => {
                          const region = name.replace('Caribbean', '\nCaribbean\n');
                          return (
                            <Col xs={6} sm={6} md={3} key={key}>
                              <Field
                                name="region"
                                type="radio"
                                value={key}
                                component={FieldFormControl}
                                validate={[isRequired]}
                                onClick={this.handleRegion}
                                onBlur={this.handleRegion}
                              >
                                <div>
                                  <RegionSelected channel={channel.key} name={key} />
                                </div>
                                {region.replace('United Kingdom', 'UK')}
                              </Field>
                            </Col>
                          );
                        })}
                      </Row>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </FormGroup>
          )}
          {size(product.metadata.trip_type) > 0 && channel.key !== 'cpi-b2c' && (
            <div className="section">
              <FormGroup controlId="trip-type">
                <Row>
                  <Col sm={3}>
                    <ControlLabel>
                      Policy Type:
                      {renderDefinition('trip_type')}{' '}
                      <OverlayTrigger
                        trigger="click"
                        rootClose={true}
                        placement="right"
                        overlay={infoIconPolicyType}
                      >
                        <FaInfoCircle className="icon-info-color-class" />
                      </OverlayTrigger>
                    </ControlLabel>
                  </Col>
                  <Col sm={9}>
                    <Row className="trip-type-container">
                      {map(product.metadata.trip_type, (name, key) => {
                        return (
                          <Col sm={6} key={key} className="trip-type-btn-container">
                            <Field
                              id={`${key}-trip`}
                              name="tripType"
                              type="radio"
                              value={key}
                              component={FieldFormControl}
                            >
                              <div className={'trip-type-btn'}>
                                {name}
                                <FaCheck/>
                              </div>
                            </Field>
                          </Col>
                        );
                      })}
                    </Row>
                  </Col>
                </Row>
              </FormGroup>
            </div>
          )}
          <div className="section">
            <FormGroup controlId="start-date">
              <Row>
                <Col componentClass={ControlLabel} sm={3}>
                  Start date:{' '}
                  <OverlayTrigger
                    trigger="click"
                    rootClose={true}
                    placement="right"
                    overlay={infoIconStartDate}
                  >
                    <FaInfoCircle className="icon-info-color-class" />
                  </OverlayTrigger>
                </Col>
                <Col sm={6}>
                  <div className="alternative-date-picker">
                    <div className="field">
                      <Field
                        name="startDate"
                        id="start-date-text-field"
                        type="masked-date"
                        placeholder="dd/mm/yyyy"
                        component={FieldFormControl}
                      />
                    </div>
                    <div className="icon">
                      <Field
                        name="startDate"
                        minDate={moment()}
                        maxDate={
                          moment().add('18', 'months')
                        }
                        component={AlternativeDatePicker}
                        validate={showRegions(tripType) ? [
                          isRequired,
                          isFutureDate,
                          isValidDate,
                          annualLimit(advancedDays),
                        ] : [
                          isRequired,
                          isFutureDate,
                          isValidDate,
                          singleLimitMonths(deferredDays[product.productCode] || 94),
                        ]}
                      />
                    </div>
                  </div>
                </Col>
              </Row>
            </FormGroup>
            {tripType === 'single' && (
              <FormGroup controlId="end-date">
                <Row>
                  <Col componentClass={ControlLabel} sm={3}>
                    Return date:{' '}
                    <OverlayTrigger
                      trigger="click"
                      rootClose={true}
                      placement="right"
                      overlay={infoIconEndDate}
                    >
                      <FaInfoCircle className="icon-info-color-class" />
                    </OverlayTrigger>
                  </Col>
                  <Col sm={6}>
                    <div className="alternative-date-picker">
                      <div className="field">
                        <Field
                          name="endDate"
                          type="masked-date"
                          id="end-date-text-field"
                          placeholder="dd/mm/yyyy"
                          component={FieldFormControl}
                        />
                      </div>
                      <div className="icon">
                        <Field
                          name="endDate"
                          minDate={returnStartDate ? moment(returnStartDate, 'DD/MM/YYYY') : moment()}
                          maxDate={startDate ? maxDateSingle() : moment()}
                          component={AlternativeDatePicker}
                          validate={
                            [
                              isRequired,
                              isFutureDate,
                              isValidDate,
                              // minTripDuration(startDate),
                              singleMaxTripDuration(startDate, tripDurations[product.productCode] || 365),
                            ]
                          }
                          value={returnStartDate}
                        />
                      </div>
                    </div>
                  </Col>
                </Row>
              </FormGroup>
            )}
          </div>
          <FieldArray
            name="travellers"
            i18n={i18n}
            product={product}
            component={Travellers}
            groupType={groupType}
            renderDefinition={renderDefinition}
            change={change}
          />
          {channel.key === 'tumc-b2c' && (
            <div className="section" style={{ borderBottom: '0px', marginBottom: '0px' }}>
              <Row style={{marginBottom: '0px', marginTop: '-5px'}}>
                <Col sm={3}>
                  <ControlLabel>
                    Existing provider{' '}
                      <OverlayTrigger
                        trigger="click"
                        rootClose={true}
                        placement="right"
                        overlay={infoIconExistingProvider}
                      >
                        <FaInfoCircle className="icon-info-color-class" />
                      </OverlayTrigger>
                  </ControlLabel>
                </Col>
                <Col sm={9}>
                  <Field
                    name="existingProvider"
                    type="text"
                    component={FieldFormControl}
                    validate={[isRequired]}
                  />
                  <div style={{fontSize: '13px'}}>
                    Who is your current travel insurance provider?
                  </div>
                </Col>
              </Row>
            </div>
          )}
          {channel.key === 'tumc-b2c' && (
            <div className="section" style={{ borderBottom: '0px', marginBottom: '0px' }}>
              <Row style={{marginBottom: '0px', marginTop: '-5px'}}>
                <Col sm={3}>
                  <ControlLabel>
                    Existing cover{' '}
                    <OverlayTrigger
                      trigger="click"
                      rootClose={true}
                      placement="right"
                      overlay={infoIconExistingCover}
                    >
                      <FaInfoCircle className="icon-info-color-class" />
                    </OverlayTrigger>
                  </ControlLabel>
                </Col>
                <Col sm={9}>
                  <Field
                    name="underlyingCover"
                    type="number"
                    component={FieldFormControl}
                    placeholder={'£'}
                    validate={
                      [
                      isRequired,
                      isNotLessThan(minAdditionalCover),
                      ]
                    }
                  />
                  <div style={{fontSize: '13px'}}>
                    How much cancellation cover do you already have (per person)?
                  </div>
                </Col>
              </Row>
            </div>
          )}
          {channel.key === 'tumc-b2c' && (
            <div className="section" style={{ borderBottom: '0px', marginBottom: '0px' }}>
              <Row style={{marginBottom: '0px', marginTop: '-5px'}}>
                <Col sm={3}>
                  <ControlLabel>
                    Additional cover{' '}
                    <OverlayTrigger
                      trigger="click"
                      rootClose={true}
                      placement="right"
                      overlay={infoIconAdditionalCover}
                    >
                      <FaInfoCircle className="icon-info-color-class" />
                    </OverlayTrigger>
                  </ControlLabel>
                </Col>
                <Col sm={9}>
                  <Field
                    name="topUpCover"
                    type="number"
                    component={FieldFormControl}
                    placeholder={'£'}
                    validate={
                      [
                        isRequired,
                        // isNotGreaterThan(maxAdditionalCover),
                      ]
                    }
                  />
                  <div style={{fontSize: '13px'}}>
                    How much additional 'Top Up' cancellation cover do you need (per person)?
                  </div>
                </Col>
              </Row>
            </div>
          )}
          <VoucherCode {...this.props}/>
          {channel.key === 'cpi-b2c' && (
            <div className="section" style={{ borderBottom: '0px', marginBottom: '0px' }}>
              <Row style={{marginBottom: '0px', marginTop: '-5px'}}>
                <Col sm={3}>
                  <ControlLabel>
                    Holiday Value{' '}
                    <OverlayTrigger
                      trigger="click"
                      rootClose={true}
                      placement="right"
                      overlay={infoIconHolidayValue}
                    >
                      <FaInfoCircle className="icon-info-color-class" />
                    </OverlayTrigger>
                  </ControlLabel>
                </Col>
                <Col sm={9}>
                  <Field
                    name="holidayValue"
                    type="number"
                    component={FieldFormControl}
                    placeholder={'£'}
                    validate={
                      [
                        isRequired,
                        isNotLessThan(0),
                        isNotGreaterThan(6000),
                      ]
                    }
                  />
                  <div style={{fontSize: '13px'}}>
                    What is the total value of the holiday booked (for the whole party)?
                  </div>
                </Col>
              </Row>
            </div>
          )}
          <div className="section">
            <Row style={{marginBottom: '10px', marginTop: '-5px'}}>
              <Col sm={12}>
                <Field
                  name="whereDidYouHearAboutUs"
                  type="text"
                  placeholder={'How did you hear about us?'}
                  component={FieldFormControl}
                />
              </Col>
            </Row>
          </div>
          <div className="section">
            <Row>
              <MarketingOptions/>
            </Row>
          </div>
          <div className="aboutUs">
            {this.renderAboutUs()}
          </div>
          <div className="btn-bar">
            <Button
              id="continue"
              bsStyle="primary"
              className="pull-right"
              onClick={this.checkForErrorBeforeSubmit}
              disabled={submitting || (submitFailed && !valid)}
            >
              Continue <FaChevronRight/>
            </Button>
          </div>
        </div>
        {
          this.renderBlockerModal()
        }
      </Form>
    );
  }
}

let selector;
let previousValues;

export default flow([
  reduxForm({
    form: 'quote',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
    onChange: (
      values: IPolicyApplication,
      dispatch,
      props: ITripDetailsFormProps,
    ) => {
      if (!previousValues) {
        previousValues = values;
        return;
      }

      let recalculateScore = false;

      if (difference(values.destinations, previousValues.destinations).length > 0) {
        recalculateScore = true;
      }

      if (values.region !== previousValues.region) {
        recalculateScore = true;
      }

      if (recalculateScore) {
        props.actions.quote.recalculateScreening();
      }

      previousValues = values;
    },
  }),
  (component) => {
    selector = formValueSelector('quote');

    return component;
  },
  connect(
    (state: IStore) => {
      const tripType = selector(state, 'tripType');
      const groupType = selector(state, 'groupType');
      const startDate = selector(state, 'startDate');
      const endDate = selector(state, 'endDate');
      const destinationsValue = selector(state, 'destinations');
      const occupationValue = selector(state, 'occupations');
      const industryValue = selector(state, 'industries');
      const region = selector(state, 'region');
      const maxTripDuration = selector(state, 'maxTripDuration');
      const residency = selector(state, 'residency');
      const quotationTypes = selector(state, 'quotationTypes');
      const schemeId = selector(state, 'schemeId');
      const cruiseCover = selector(state, 'cruiseCover');
      const travellers = selector(state, 'travellers');
      const topUpCover = selector(state, 'topUpCover');
      const existingProvider = selector(state, 'existingProvider');
      const underlyingCover = selector(state, 'underlyingCover');
      const holidayValue = selector(state, 'holidayValue');

      return {
        cruiseCover,
        tripType,
        quotationTypes,
        residency,
        region,
        maxTripDuration,
        groupType,
        startDate,
        schemeId,
        endDate,
        destinationsValue,
        occupationValue,
        industryValue,
        travellers,
        auth: state.auth,
        channel: state.branding.channel,
        topUpCover,
        existingProvider,
        underlyingCover,
        holidayValue,
      };
    },
    (dispatch) => ({
      actions: {
        submit: bindActionCreators(submit, dispatch),
        quote: bindActionCreators({...quoteActions}, dispatch),
      },
    }),
  ),
])(TripDetailsForm);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/scenes/TripDetails/index.tsx